import React, { useContext } from "react";
import { Button, TextField } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const StatusComment = ({ statusComment, status, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);
    const scrollToBox = () => {
        const boxElement = document.getElementById("boxFileManager");
        if (boxElement) {
            boxElement.scrollIntoView({ behavior: "smooth" });
        }
    }

    return (
        <div id="statusComment" className="planField">
            <GroupBDRBiologists/>
            <div style={{ display: "flex", alignItems: "center" }}>
                <TextField
                    name="statusComment"
                    label={status === "Withdrawn" ? "Withdrawal Comment"
                            : status === "Completed" ? "Completion Comment"
                                : xplanLabels.statusComment
                    }
                    InputLabelProps={{ shrink: true }}
                    type="text"
                    required={required.includes("statusComment")}
                    value={statusComment ? statusComment : ""}
                    onChange={(e) => handleChange("statusComment", e.target.value)}
                    multiline
                    minRows={1}
                    className="fullLength"
                    disabled={!canEdit}
                />
                {status === "Completed" &&
                    <div style={{ marginLeft: '12px' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            component="span"
                            className="boxFileManagerHeaderUpload"
                            onClick={scrollToBox}
                        >
                            <div className="boxFileManagerHeaderUploadContent">
                                <CloudUpload />
                                <span style={{ marginTop: "3px" }}>UPLOAD</span>
                            </div>
                        </Button>
                    </div>
                }
            </div>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"statusComment"} />}
        </div>
    );
};

export default StatusComment;